import { useStoreUIV1 } from '@gimlite/ui-v1';
import { observer } from 'mobx-react-lite';
import {
  createBrowserRouter,
  Navigate,
  Outlet,
  RouterProvider,
} from 'react-router-dom';
import { config, portal } from './config';
import { MainUse } from './main';
import { BreakdownsPage } from './pages/breakdowns/breakdowns.page';
import { ContractPage } from './pages/contracts/contracts.page';
import { DashboardPage } from './pages/dashboard/dashboard.page';
import { IncidentPage } from './pages/incidents/incidents.page';
import { MotoristConfirm } from './pages/motorist-confirm/motorist-confirm';
import { ProductPage } from './pages/products/products.page';
import { SessionPage } from './pages/sessions/session.page';
import { TenantConfirm } from './pages/tenant-confirm/tenant-confirm';

export const CustomRouter = observer(() => {
  const { SSOStore } = useStoreUIV1();

  const sitemap = [
    {
      path: '*',
      element: <Navigate to={`/`} />,
    },
    {
      path: '/verificator',
      element: portal === 'operator' ? <MotoristConfirm /> : <TenantConfirm />,
    },
    {
      path: '/',
      element: <MainUse />,
      children: [
        {
          path: ':parkingId',
          element: <Outlet />,
          children: [
            {
              index: true,
              element: <DashboardPage />,
            },
            {
              path: 'dashboard',
              element: <DashboardPage />,
            },
            {
              path: 'sessions',
              element: <SessionPage />,
              children: [
                {
                  path: ':sessionId',
                  element: <SessionPage />,
                },
              ],
            },
            {
              path: 'contracts',
              element: <ContractPage />,
              children: [
                {
                  path: ':contractId',
                  element: <ContractPage />,
                },
              ],
            },
            ...(config.PORTAL === 'operator'
              ? [
                  {
                    path: 'breakdowns',
                    element: <BreakdownsPage />,
                    children: [
                      {
                        path: ':breakdownId',
                        element: <BreakdownsPage />,
                      },
                    ],
                  },
                ]
              : []),
            {
              path: 'incidents',
              element: <IncidentPage />,
              children: [
                {
                  path: ':incidentId',
                  element: <IncidentPage />,
                },
              ],
            },
            ...(config.PORTAL === 'operator'
              ? [
                  {
                    path: 'products',
                    element: <ProductPage />,
                  },
                ]
              : []),
          ],
        },
      ],
    },
  ];

  return SSOStore.exceptionPath.includes(window.location.pathname) ||
    (SSOStore.authenticated && SSOStore.user) ? (
    <RouterProvider router={createBrowserRouter(sitemap)}></RouterProvider>
  ) : null;
});
